module.exports = new __parcel__URL__("roughness0.95338426.jpg").toString();